export default "__VITE_ASSET__CVAFlAac__"